import type { AbstractControl, ValidationErrors } from '@angular/forms';
import {
  ADDRESS_VALIDATION_ERROR_KEYS,
  requiredTrimmedValidator,
} from './address-field.validators';

/** Maximum length for postal code fields. */
export const POSTAL_CODE_MAX_LENGTH = 10;

/** Legacy OLS GUI postal code regex from GlobalConstants.REGEX_GUI_POSTALCODE. */
export const LEGACY_GUI_POSTAL_CODE_REGEX = /^([A-Za-z]\d[A-Za-z] ?-?\d[A-Za-z]\d)$/;

/**
 * Validates Canadian postal code format for Phase 1 domestic (CA-only) shipments.
 */
export function isValidCanadianPostalCode(value: string): boolean {
  return LEGACY_GUI_POSTAL_CODE_REGEX.test(value.trim().toUpperCase());
}

/**
 * Required Canadian postal code validator aligned with legacy OLS GUI rules.
 */
export function canadianPostalCodeValidator(control: AbstractControl): ValidationErrors | null {
  const requiredError = requiredTrimmedValidator(control);

  if (requiredError) {
    return requiredError;
  }

  const value = typeof control.value === 'string' ? control.value : '';

  return isValidCanadianPostalCode(value)
    ? null
    : { [ADDRESS_VALIDATION_ERROR_KEYS.postalCodeInvalid]: true };
}
